import { Trans } from '@lingui/macro';
import { FC } from 'react';

import AuthLayout from '@/UI/auth-layout';
import Login from '@/components/Login/Login';

const LoginPage: FC = () => {
    return (
        <AuthLayout
            header={<Trans>Welcome To Covchat</Trans>}
            subHeader={
                <>
                    <Trans>Fill in the required information to login</Trans>.
                </>
            }>
            <Login />
        </AuthLayout>
    );
};
export default LoginPage;
